var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageCasesOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 7,
    viewBox: "0 0 20 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.15 5.268C0.114 5.364 0.054 5.538 0.054 5.646C0.054 5.91 0.24 6.078 0.51 6.078C0.744 6.078 0.882 6 0.948 5.808L1.206 5.088H2.79L3.042 5.808C3.114 6 3.27 6.078 3.486 6.078C3.738 6.078 3.948 5.886 3.948 5.646C3.948 5.538 3.888 5.364 3.852 5.268L2.664 1.962C2.556 1.656 2.358 1.602 2.136 1.602H1.902C1.662 1.602 1.506 1.68 1.422 1.902L0.15 5.268ZM2.574 4.404H1.422L2.004 2.67H2.016L2.574 4.404Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.258 3.684C19.258 3.054 18.676 2.784 17.836 2.784C16.936 2.784 16.444 3.228 16.444 3.576C16.444 3.756 16.594 3.912 16.816 3.912C17.164 3.912 17.182 3.432 17.83 3.432C18.124 3.432 18.382 3.54 18.382 3.792C18.382 4.044 18.214 4.092 18.004 4.116L17.47 4.176C16.798 4.254 16.246 4.458 16.246 5.184C16.246 5.736 16.738 6.078 17.236 6.078C17.698 6.078 18.094 5.946 18.436 5.568C18.448 5.838 18.574 6.078 18.952 6.078C19.162 6.078 19.348 5.94 19.348 5.742C19.348 5.604 19.258 5.52 19.258 5.154V3.684ZM18.382 4.866C18.382 5.19 18.088 5.502 17.608 5.502C17.308 5.502 17.122 5.34 17.122 5.142C17.122 4.878 17.32 4.764 17.686 4.71L18.004 4.662C18.106 4.644 18.286 4.614 18.382 4.524V4.866Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.5H14.917",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5615 2.5L14.9155 4.5",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9155 4.5L12.5615 6.5",
    stroke: "#272D55",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCasesOperationIcon);
export default __webpack_public_path__ + "static/media/ManageCasesOperationIcon.79ce646b0bbf9bab62729f3bf74b5745.svg";
export { ForwardRef as ReactComponent };